import { IServiceWithESimToActivate } from "@features/ManageSim/interface/IServiceWithESimToActivate";
import { EESimStatus } from "@pages/AccountDetails/interface/IAccountDetailsPage";

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface IServiceWithESimToActivateListResponse {
    serviceId: string;
    phoneNumber: string;
    activationQrCode: string;
    activationQrCodeFormat: string;
    esimStatus: string;
    esimPassCode: string;
}

export const getResponseToState = (
    serviceWithESimToActivateListResponse: IServiceWithESimToActivateListResponse[]
): IServiceWithESimToActivate[] =>
    serviceWithESimToActivateListResponse.map((serviceResponse) => ({
        serviceId: serviceResponse.serviceId,
        phoneNumber: serviceResponse.phoneNumber,
        activationQrCode: serviceResponse.activationQrCode,
        activationQrCodeFormat: serviceResponse.activationQrCodeFormat,
        esimStatus: serviceResponse.esimStatus as EESimStatus,
        esimPassCode: serviceResponse.esimPassCode,
    }));
